<template>
    <v-tabs-items
        :value="value"
        style="width:100%; padding-bottom: 20px"
        @change="updateSelected"
    >
        <v-tab-item
            v-for="tab in allTabs"
            :key="tab.name"
            :transition="false"
            :reverse-transition="false"
        >
            <slot
                name="content"
                :tab="tab"
            />
        </v-tab-item>
    </v-tabs-items>
</template>

<script>

export default {
    name: "AppStoreTabsItems",
    props: {
        value: {
            type: Number,
            default: 0
        },
        allTabs: {
            type: Array,
            default: () => ([])
        }
    },
    setup(props, ctx) {

        const updateSelected = function (value){
            ctx.emit('input', value)
        }
        return {
            updateSelected
        }
    }
};
</script>